import { Component, Host, h, Prop, Watch } from '@stencil/core';
import { CssClassMap } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-modal',
  styleUrl: 'cms-modal.scss',
  shadow: false,
})
export class CmsModal {
  /**
   * set Modal is open or closed
   */
  @Prop({ mutable: true }) open = false;

  /**
   * set the Content from outside in the end of the html body
   */
  @Prop() setModalContent: string;

  @Watch('setModalContent')
  private onSetModalContentChange() {
    return this.setModalContent;
  }

  private getCssClassMap(): CssClassMap {
    return {
      ['cms-modal-overlay']: true,
      ['is-visible']: this.open,
    };
  }

  private closeModal() {
    this.open = false;
  }

  render() {
    return (
      <Host
        onClick={() => {
          this.closeModal();
        }}
      >
        <div class={this.getCssClassMap()} role='document'>
          <div class='cms-modal-inner'>
            <button
              onClick={() => {
                this.closeModal();
              }}
              type='button'
              class='cms-modal-close'
              aria-label='Close'
            >
              <span class='close-text' aria-hidden='true'>
                close &times;
              </span>
            </button>

            <div
              class='cms-modal-content'
              innerHTML={
                this.setModalContent ? this.onSetModalContentChange() : null
              }
            ></div>
          </div>
        </div>
      </Host>
    );
  }
}
